import { API_CONFIG } from '../config/api.config';
import { BaseApiClient } from './base-client';

class CfWorkerApiClient extends BaseApiClient {
  protected baseUrl = API_CONFIG.CF_WORKER_BASE_URL;
}

export const cfApiClient = new CfWorkerApiClient();
